import * as React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Input, message } from 'antd';
import * as _ from 'lodash';
import '@style/component/input/input-group.less';

export interface InputGroupStateInfo {
  inputText: string;
}

export interface InputGroupPropsInfo {
  className?: string;
  title?: string;
  placeholder?: string;
  data?: string[];
  selectWords?: string[];
  onUpdate: (data: string[], selectedWords?: string[], del?: string) => void;
  onSelect?: (data: string[]) => void;
  tooltips?: JSX.Element | string;
}

export class InputGroup extends React.Component<
  InputGroupPropsInfo,
  InputGroupStateInfo
> {
  constructor(props: InputGroupPropsInfo) {
    super(props);

    this.state = {
      inputText: ''
    };
  }

  onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputText = event.target.value;

    this.setState({
      inputText
    });
  };

  onCreate = (value: string) => {
    const { data, onUpdate } = this.props;

    if (!value) {
      // message.error('输入不能为空！');
    } else if ((data || []).indexOf(value) > -1) {
      message.warning('输入内容已存在');
    } else {
      const nextData = [...(data || []), value];

      this.setState(
        {
          inputText: ''
        },
        () => {
          onUpdate(nextData);
        }
      );
    }
  };

  onTextBlur = (index: number, event: React.FocusEvent<HTMLSpanElement>) => {
    const { data, onUpdate } = this.props;
    const nextData = [...(data || [])];

    if (nextData[index]) {
      nextData[index] = event.currentTarget.innerText.replace(/\n/g, '');
    }

    onUpdate(nextData);
  };

  deleteItem = (item: string) => {
    const { data, selectWords = [], onUpdate } = this.props;
    let nextSelectWords = _.cloneDeep(selectWords);
    const delSelectedWords = nextSelectWords.filter((word: string) =>
      item.includes(word)
    );

    const nextData = (data || []).filter(thisItem => item !== thisItem);

    delSelectedWords.forEach((del: string) => {
      let flag = true;
      nextData.forEach((next: string) => {
        if (next.includes(del)) {
          flag = false;
        }
      });

      if (flag) {
        nextSelectWords = nextSelectWords.filter(
          (target: string) => target !== del
        );
      }
    });

    onUpdate(nextData, nextSelectWords, item);
  };

  onTextSelect = () => {
    const { data, selectWords, onSelect } = this.props;
    const selectedText = (window as any).getSelection().toString();

    if (onSelect && selectedText) {
      let nextSelectWords = [...(selectWords || [])];

      if (nextSelectWords.indexOf(selectedText) === -1) {
        for (const [i, text] of (selectWords || []).entries()) {
          if (selectedText.includes(text) || text.includes(selectedText)) {
            return;
          }
        }

        nextSelectWords.push(selectedText);
      } else {
        nextSelectWords = nextSelectWords.filter(item => item !== selectedText);
      }

      onSelect(nextSelectWords);
    }
  };

  parseSelectWords = () => {
    const { data, selectWords } = this.props;
    const textList: string[] = (data || []).map((item, index) => {
      let nextItem = _.cloneDeep(item);

      (selectWords || []).map((word, wordIndex) => {
        nextItem = nextItem.replace(
          word,
          `<span style="background-color: #ffb59e;margin:0 4px;padding:2px">${word}</span>`
        );
      });

      return nextItem;
    });

    return textList;
  };

  render() {
    const { inputText } = this.state;
    const {
      className,
      placeholder,
      title,
      data,
      onSelect,
      tooltips
    } = this.props;
    const textList = this.parseSelectWords();

    return (
      <div className={`component-input-group ${className || ''}`}>
        <div className="group-title">
          <h3>{title}</h3>
          <span className="title-tooltips">{tooltips || ''}</span>
        </div>
        <div className="group-body">
          <Input
            type="text"
            value={inputText}
            placeholder={placeholder}
            onChange={this.onInputChange}
            onPressEnter={(event: React.KeyboardEvent<HTMLInputElement>) =>
              this.onCreate(event.currentTarget.value)
            }
            onBlur={(event: React.FocusEvent<HTMLInputElement>) =>
              this.onCreate(event.currentTarget.value)
            }
          />
          <>
            {(data || []).map((item, index) => (
              <div key={item} className="input-item">
                <div
                  onSelect={onSelect ? this.onTextSelect : undefined}
                  className="item-name"
                  contentEditable={true}
                  suppressContentEditableWarning={true}
                  onBlur={this.onTextBlur.bind(this, index)}
                  onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
                    if (e.which === 13) {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                  dangerouslySetInnerHTML={{ __html: textList[index] }}
                />
                <DeleteOutlined className="attr-remove" onClick={this.deleteItem.bind(this, item)} />
              </div>
            ))}
          </>
        </div>
      </div>
    );
  }
}
